// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * Temporary model for Coding Rules - will be replaced with auto-generated version
 *
 * TODO: Replace with auto-generated version when backend provides OpenAPI spec
 *
 * NOTE: This class is manually created as a temporary solution.
 */

export interface SupportCodingRule {
    ruleNumber: number;
    description: string;
    isActive: boolean;
    created: string;
}

export interface ProviderCodingRule {
    ruleNumber: number;
    description: string;
    isActive: boolean;
    created: string;
}

export function SupportCodingRuleFromJSON(json: any): SupportCodingRule {
    return {
        ruleNumber: json['ruleNumber'],
        description: json['description'],
        isActive: json['isActive'],
        created: json['created'],
    };
}

export function ProviderCodingRuleFromJSON(json: any): ProviderCodingRule {
    return {
        ruleNumber: json['ruleNumber'],
        description: json['description'],
        isActive: json['isActive'],
        created: json['created'],
    };
}
